import { useLanguageContext } from "../../../../../context/LanguageContext";
import LanguageFormSelectView from "./LanguageFormSelectView";

function LanguageFormSelect({ value, onChange, disabled, nullable }) {
  const languageContext = useLanguageContext();

  return (
    <LanguageFormSelectView
      options={languageContext.activeLanguages.map((lang) => ({
        label: lang.label,
        value: lang.id,
      }))}
      value={value}
      onChange={onChange}
      disabled={disabled}
      nullable={nullable}
    />
  );
}

export default LanguageFormSelect;
